(function () {
  if (window.gmPackIncludesInit) return;
  window.gmPackIncludesInit = true;

  function selectedValues(scope) {
    var values = [];
    scope.querySelectorAll('input[type="radio"]:checked, select').forEach(function (el) {
      if (el.value) values.push(el.value);
    });
    return values;
  }

  function update(module) {
    var scope = module.closest('[id^="shopify-section-"]') || document;
    var values = selectedValues(scope);
    module.querySelectorAll('[data-gm-pack-detail]').forEach(function (el) {
      var map;
      try { map = JSON.parse(el.getAttribute('data-gm-pack-map') || '{}') || {}; } catch (e) { return; }
      var text = el.getAttribute('data-gm-pack-default') || '';
      for (var i = 0; i < values.length; i++) {
        if (Object.prototype.hasOwnProperty.call(map, values[i]) && map[values[i]]) {
          text = map[values[i]];
          break;
        }
      }
      el.textContent = text;
      el.hidden = !text;
    });
  }

  document.addEventListener('change', function (event) {
    document.querySelectorAll('[data-gm-pack-includes]').forEach(function (module) {
      var scope = module.closest('[id^="shopify-section-"]');
      if (!scope || scope.contains(event.target)) update(module);
    });
  });
})();